export enum LocaleStorageEnum {
  ORGANIZATION_ID = 'Organization',
  LANGUAGE = 'language',
}
